// LatestBlogs.jsx
import React from 'react';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import { FaCalendarAlt, FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import '../../assets/css/student/blogs/LatestBlogs.css';

const LatestBlogs = () => {
  const blogsData = [
    {
      id: 1,
      badge: 'Donation Awareness',
      badgeColor: '#28a745',
      image: 'https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=400',
      title: 'How Your Donations Change Student Lives',
      description: 'Discover the impact of your contributions on students education and future.',
      date: 'April 22, 2024',
      author: 'Admin'
    },
    {
      id: 2,
      badge: 'Education Support',
      badgeColor: '#007bff',
      image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=400',
      title: 'Success Stories: Students Achieving Their Dreams',
      description: 'Read inspiring stories of students who succeeded thanks to generous donors.',
      date: 'April 18, 2024',
      author: 'Admin'
    },
    {
      id: 3,
      badge: 'NGO Updates',
      badgeColor: '#ff9800',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400',
      title: 'The Role of NGOs in Supporting Education',
      description: 'Learn how NGOs verify and assist students in need of financial help to continue their studies.',
      date: 'April 15, 2024',
      author: 'Admin'
    }
  ];

  return (
    <section className="latest-blogs-section">
      <Container>
        <div className="blogs-header text-center">
          <h2 className="blogs-title">Latest Blogs</h2>
          <p className="blogs-subtitle">
            Read our latest articles and stories about supporting deserving students.
          </p>
        </div>

        <Row>
          {blogsData.map((blog) => (
            <Col lg={4} md={6} sm={12} key={blog.id} className="mb-4">
              <div className="blog-card">
                <div className="blog-image-wrapper">
                  <img src={blog.image} alt={blog.title} className="blog-image" />
                  <Badge className="blog-badge" style={{ backgroundColor: blog.badgeColor }}>
                    {blog.badge}
                  </Badge>
                </div>

                <div className="blog-content">
                  <h5 className="blog-title">{blog.title}</h5>
                  <p className="blog-description">{blog.description}</p>
                  <div className="blog-meta">
                    <span className="meta-item"><FaCalendarAlt size={12} /> {blog.date}</span>
                    <span className="meta-item"><FaUser size={12} /> {blog.author}</span>
                  </div>

                  {/* Link to single blog detail */}
                  <Link to={`/blogs/${blog.id}`} className="read-more-link">
                    Read More →
                  </Link>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default LatestBlogs;